import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from 'react';
import GlobalStyle from '../../styles/global';
import Footer from '../Footer';
import Header from '../Header';
import { MiawChat } from '../MiawChat';
import ReactGA from 'react-ga4';
import { GA4ID } from '@/constants/analytics';

import * as S from './styles';

const Layout = ({ children, blog, path, className }) => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      disable: 'phone',
      once: true,
    });

    ReactGA.initialize(GA4ID);
  }, []);

  return (
    <>
      <GlobalStyle />
      <Header blog={blog} path={path} />

      <S.Main className={className}>{children}</S.Main>

      <MiawChat />
      <Footer />
    </>
  );
};

export default Layout;
